

































































import { defineComponent, computed } from '@nuxtjs/composition-api';
import { addCurrency, getCurrencyAffixes, getPriceParts, priceFormat } from '~/helpers/utils';
import { useTranslations } from '@vue-storefront/novulo';

export default defineComponent({
  name: 'Price',
  props: {
    currentPrice: {
      type: Number,
      required: true,
      default: 0
    },
    advisedPrice: {
      type: Number,
      required: false,
      default: 0
    },
    cashDiscountPrice: {
      type: Number,
      default: 0
    },
    cashbackPrice: {
      type: Number,
      required: false,
      default: 0
    },
    priceAlignVCenter: {
      type: Boolean,
      default: false
    },
    isCart: {
      type: Boolean,
      default: false
    },
    isFreeProduct: {
      type: Boolean,
      default: false
    }
  },
  setup(props) {
    const { translate } = useTranslations();

    const currencyAffixes = computed(() => getCurrencyAffixes());
    const showMSRP = computed(
      () =>
        props.advisedPrice && !(props.advisedPrice <= props.currentPrice * 1.01)
    );
    const showStrikethrough = computed(
      () =>
        props.cashDiscountPrice && props.cashDiscountPrice < props.currentPrice
    );
    const showCashbackPrice = computed(
      () =>
        props.cashbackPrice &&
        props.cashbackPrice <
          (showStrikethrough ? props.cashDiscountPrice : props.currentPrice)
    );

    const strikethroughPrice = computed(() => getPriceParts(props.currentPrice));
    const actualPrice = computed(() => {
      const price = showStrikethrough.value
        ? props.cashDiscountPrice
        : props.currentPrice;

      return getPriceParts(price);
    });

    return {
      addCurrency,
      currencyAffixes,
      showMSRP,
      showStrikethrough,
      showCashbackPrice,
      strikethroughPrice,
      actualPrice,
      priceFormat,
      translate
    };
  }
});
